export default "__VITE_ASSET__DKHF$haR__"